import './style.css'

const ViewSubtitle = props => {
  return (
    <h5 className="ViewSubtitle">
      { props.children }
    </h5>
  )
}

export default ViewSubtitle
